import script from "./CardComponente.vue?vue&type=script&setup=true&lang=js"
export * from "./CardComponente.vue?vue&type=script&setup=true&lang=js"

import "./CardComponente.vue?vue&type=style&index=0&id=3a7b97cd&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a7b97cd"]])

export default __exports__